
import {
  minLength,
  required
} from "vuelidate/lib/validators";
import {getAdditionalData, parseUtmLabels} from "~/helpers/formSend";
import errorParseNetwork from "~/helpers/errorParseNetwork";
import DadataInput from "~/components/dadata/DadataInput.vue";

export default {
  name: "FormFeedback",

  components: {
    DadataInput,
  },

  data: function () {
    return {
      form: {
        organization: "",
        name: "",
        phone: ""
      },
      isAccept: false,
      organizationInn: "",
    }
  },

  props: {
    isHome: {
      type: Boolean,
      required: false,
    }
  },

  computed: {
    errorOrganization: function () {
      const error = this.$v?.form?.organization;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }
      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Проверьте название организации"
      }
    },
    errorPhone: function () {
      const error = this.$v?.form?.phone;
      if (!error?.$invalid || !error?.$dirty) {
        return null
      }

      if (!error.required) {
        return "Обязательно к заполнению"
      }
      if (!error.minLength) {
        return "Неправильный формат ввода"
      }

      return null
    },

    isUseRecaptcha: function () {
      return Boolean(this.$store.state.appState?.config?.useReCaptchaForForms)
    },
  },

  validations: function () {
    const form = {
      organization: {
        required,
        minLength: minLength(3)
      },
      phone: {
        required,
        minLength: minLength(18)
      },
    };

    return {
      form,
    };
  },

  methods: {
    resetForm: function () {
      this.form = {
        organization: "",
        name: "",
        phone: "",
      };
      this.organizationInn = "";
      this.$v.$reset();
    },
    submitForm: async function (codeRecaptcha = '') {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      const org = (this.form.organization || "").trim(); // полная организация
      const personName = (this.form.name || "").trim(); // имя пользователя
      const combinedName =  (org + " " + personName).trim(); // [org, personName].filter(Boolean).join(" "); // имя + орг

      let body = {
        type: "Обратный звонок",
        name: personName, //combinedName, сюда поле Юзера
        phone: (this.form?.phone || "").replace(/[^\d]/g, ''),
        url: window.location.href
      };

      if (this.isUseRecaptcha && !codeRecaptcha) {
        this.$store.commit("recaptcha/onOpen", {
          onSubmit: this.submitForm.bind(this)
        })
        return
      }
      if (this.isUseRecaptcha && codeRecaptcha) {
        body['g-recaptcha-response'] = codeRecaptcha;
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: true });
      const utmLabels = parseUtmLabels();
      body.additional_data = {
        ...(body.additional_data || {}),
        ...(utmLabels || {}),
        organization_name: org,
        organization_inn: this.organizationInn || "",
      };
      body.source = this.$cookies.get('sbjs_current') || '';
      body.additional_data = await getAdditionalData({...body.additional_data}, {
        $yandexMetrika: this.$yandexMetrika
      });

      const response = await this.$api.agent.transport.post("/form/send", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {
          error: errorParseNetwork(err.response)
        }
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
        this.$toast.error(response.error);

        return
      }

      this.$yandexMetrika.reachGoal("peresvonut_mne");
      this.$yaglaaction('peresvonut_mne');
      this.resetForm();
      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
      this.$toast.success("Заявка успешно отправлена");
    },

    onOrganizationMeta: function (org) {
      this.organizationInn = (org && org.inn) || "";
    },
  }
}
